import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const SignInPrompt = () => {
  return (
    <div className="w-full text-center">
      <div className="inline-flex items-center gap-2 text-sm text-muted-foreground">
        <span>Already have an account?</span>
        <Link 
          to="/login" 
          className="inline-flex items-center gap-1.5 font-semibold text-primary hover:text-primary/80 transition-colors"
        >
          <span>Sign In</span>
          <Icon name="ArrowRight" size={16} />
        </Link>
      </div>
    </div>
  );
};

export default SignInPrompt;